// extracted by mini-css-extract-plugin
export default {"drawer-menu__header":"DrawerMenu_drawer-menu__header__m+NfS"};